type CheckboxListProps = {
  title: string;
  col: string;
  items: Array<ItemProps>;
  filterType: string;
  filterState: any;
  handleFilterClick: any;
};

type ItemProps = {
  label: string;
  value: number | string;
  total: number | undefined;
};

const CheckboxItem = ({ item, handleFilterClick, filterState, filterType }) => {
  const { label, value, total } = item as ItemProps;
  const isActive = filterState.includes(value);
  return (
    <div
      className="checkbox-button"
      onClick={() => handleFilterClick({ value, filterType })}
    >
      <input
        type="checkbox"
        name={`checkbox-${label}`}
        value={value}
        checked={isActive}
        readOnly={true}
      />
      <label htmlFor={`checkbox-${label}`}>
        <span>{label}</span>
        <span className={'checkbox-button-nbr'}>{total}</span>
      </label>
    </div>
  );
};

export default function CheckboxList({
  title,
  col,
  items,
  filterState,
  // attribute,
  filterType,
  handleFilterClick,
}: CheckboxListProps) {
  return (
    <ul className="checkboxes">
      <p className="checkboxes__title">{title}</p>
      <div className={`checkbox-button-grid checkbox-button-grid--${col}`}>
        {items.map((item, i) => (
          <CheckboxItem
            item={item}
            key={i}
            handleFilterClick={handleFilterClick}
            filterState={filterState}
            filterType={filterType}
          />
        ))}
      </div>
    </ul>
  );
}
